// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import CollapseController from "./collapse_controller"
application.register("collapse", CollapseController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import ImagePreviewController from "./image_preview_controller"
application.register("image-preview", ImagePreviewController)

import MagicLinkController from "./magic_link_controller"
application.register("magic-link", MagicLinkController)

import ProductAssignmentController from "./product_assignment_controller"
application.register("product-assignment", ProductAssignmentController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)
